import React from "react";
import Button from "../../../../../shared-components/css-modules/toyota/atoms/Button";
import type { CtaButtonType } from "../../../../utils/types/AceConfigType";
import useCtaButton from "../../../../hooks/useCtaButton";

const CtaButton = ({
    ctaConfig,
    sizing,
    className,
    useOrderCtaTracking = false,
}: {
    ctaConfig: CtaButtonType;
    sizing?: "xs" | "sm" | "lg" | "full-width" | "pill";
    className?: string;
    useOrderCtaTracking?: boolean;
}): JSX.Element => {
    const { title, onClick, isPrimary, disabled } = useCtaButton(ctaConfig, useOrderCtaTracking);

    return (
        <Button
            variant={isPrimary ? "btn-default" : "btn-secondary"}
            href={!disabled ? ctaConfig.url : ""}
            onClick={(event) => {
                onClick(event);
            }}
            sizing={sizing}
            className={className}
            disabled={disabled}
        >
            {title}
        </Button>
    );
};

export default CtaButton;
